import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the X (Twitter) Advanced Search Generator tool
 * Separated from view layer for maintainability
 */
export const xAdvancedSearchFAQ: FAQItem[] = [
  {
    question: "How does X Advanced Search work?",
    answer:
      "The tool helps you build complex X (Twitter) search queries using a visual interface instead of memorizing operators. You specify words, accounts, dates, engagement metrics, and filters, and the tool generates a search query that works directly in X's search bar. It handles all the syntax like 'from:', 'filter:', 'min_replies:', etc. automatically.",
  },
  {
    question: "What search operators does it support?",
    answer:
      "The tool supports all major X search operators including: exact phrases (quotes), hashtags, account filters (from:, to:, mentions), language filters, date ranges (since:, until:), engagement filters (min_replies:, min_faves:, min_retweets:), content filters (replies, links, images, videos), and boolean logic (AND, OR, NOT).",
  },
  {
    question: "Can I search for tweets from specific accounts?",
    answer:
      "Yes! You can search for tweets from specific accounts using the 'From these accounts' field, tweets sent to specific accounts with 'To these accounts', or tweets mentioning specific accounts. You can enter multiple accounts separated by spaces, and the tool will format them correctly with the 'from:', 'to:', or '@' operators.",
  },
  {
    question: "How do I filter by engagement metrics?",
    answer:
      "You can set minimum thresholds for replies, likes (faves), and retweets. For example, if you want to find viral tweets, you could set min_faves to 1000 to only see tweets with at least 1000 likes. This is perfect for finding popular content, trending discussions, or high-engagement posts.",
  },
  {
    question: "Can I search by date range?",
    answer:
      "Yes! Use the 'Since' and 'Until' date fields to search for tweets within a specific time period. Enter dates in YYYY-MM-DD format (e.g., 2024-01-01). This is useful for finding tweets from a specific event, tracking discussions over time, or researching historical social media data.",
  },
  {
    question:
      "What's the difference between 'include', 'exclude', and 'only' for replies and links?",
    answer:
      "'Include' means show all tweets including replies/links. 'Exclude' means hide replies/links and show only original tweets. 'Only' means show exclusively replies or tweets with links. This helps you filter out noise—for example, excluding replies to focus on original content, or showing only tweets with links to find shared articles.",
  },
  {
    question: "How do I use the generated query?",
    answer:
      "After building your search, you can copy the generated query to your clipboard and paste it into X's search bar, or click 'Search on X' to open 𝕏 directly with your query. The query uses X's native search syntax, so it works exactly as if you typed all the operators manually.",
  },
  {
    question: "Is this tool free?",
    answer:
      "Yes, completely free with no registration required. You can build as many search queries as you need. There are no limits, no watermarks, and no hidden fees. It's part of our free tools collection to help researchers, marketers, and anyone who needs to find specific content on X (Twitter).",
  },
];
